// Width of the trailing action column in the media list view, shared by the row
// (MediaProfileCardList) and the column header (search/InfiniteHits) so their columns stay
// aligned. The row fills this column with its content; the header reserves it as empty space.
// Rows that may message fit the "Start a Conversation" button + bookmark; the rest hold only the
// bookmark.
const mediaListActionColumnWidth = (canMessage) => (canMessage ? 220 : 24);

export default mediaListActionColumnWidth;
